var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"img_box"},[_c('img',{attrs:{"src":require("../../assets//images/promotional_1.png"),"alt":""}}),_c('img',{attrs:{"src":require("../../assets//images/promotional_2.jpg"),"alt":""}})])])])
}]

export { render, staticRenderFns }